import { useState, useEffect } from "react";
import { getMessageFromApp } from "utils/webview";

export default function useGetEventFromApp() {
  const [parsedMessage, setParsedMessage] = useState<any>();

  useEffect(() => {
    const cleanup = getMessageFromApp(setParsedMessage);
    return cleanup;
  }, []);

  return parsedMessage;
}
